// ─────────────────────────────────────────────────────────────────────────────
// i18n/locales/de.ts – Deutsch (Standard) – VOLLSTÄNDIG
// ─────────────────────────────────────────────────────────────────────────────
export default {
  lang: { de: 'Deutsch', fr: 'Français', it: 'Italiano', en: 'English', es: 'Español', pt: 'Português' },

  nav: {
    // Menuepunkt der Uebersichtsseite `/dashboard` (T-M41.3, REQ-OPS-035
    // Praez. 1 (a)). Bewusst EIGEN neben `nav.dashboard`: jener Schluessel
    // beschriftet die Herkunft eines von Hand angelegten Auftrags (JobCard)
    // und den Rueckweg aus der Aktionsseite, nicht diesen Menuepunkt.
    overview:     'Übersicht',
    dashboard:    'Dashboard',
    jobs:         'Druckaufträge',
    fleet:        'Flotte',
    printers:     'Drucker',
    schankanlage: 'Schankanlage',
    printserver:  'Printserver',
    settings:     'Einstellungen',
    users:        'Benutzer',
    company:      'Firma',
    locations:    'Standorte',
    smtp:         'E-Mail SMTP',
    api:          'API',
    switchCompany:'Firma wechseln',
    selectCompany:'Firma auswählen',
    logout:       'Abmelden',
  },

  common: {
    save:          'Speichern',
    saving:        'Wird gespeichert …',
    cancel:        'Abbrechen',
    delete:        'Löschen',
    deleting:      'Wird gelöscht …',
    edit:          'Bearbeiten',
    add:           'Hinzufügen',
    back:          'Zurück',
    loading:       'Wird geladen …',
    search:        'Suchen …',
    yes:           'Ja',
    no:            'Nein',
    confirm:       'Bestätigen',
    confirmDelete: 'Wirklich löschen?',
    cannotUndo:    'Diese Aktion kann nicht rückgängig gemacht werden.',
    new:           'Neu',
    optional:      '(optional)',
    unknown:       '—',
    active:        'Aktiv',
    inactive:      'Inaktiv',
    enabled:       'Aktiviert',
    disabled:      'Deaktiviert',
    seconds:       'Sek.',
    minutes:       'Min.',
    noData:        'Keine Daten vorhanden.',
    close:         'Schliessen',
    remove:        'Entfernen',
    copy:          'Kopieren',
    copied:        'Kopiert!',
    change:        'Ändern',
    send:          'Senden',
    sending:       'Wird gesendet …',
    processing:    'Wird verarbeitet …',
    show:          'Anzeigen',
    hide:          'Verbergen',
    yesDelete:     'Ja, löschen',
    yesRemove:     'Ja, entfernen',
    note:          'Hinweis',
    error:         'Fehler',
    version:       'Version',
    // Kennzahl, die NICHT serverseitig gezaehlt ist: Untergrenze (REQ-OPS-034)
    count: {
      atLeast:      'Mindestens {count}',
      atLeastShort: '≥ {count}',
      atLeastHint:  'Aus der geladenen Liste abgeleitet – es sind mindestens so viele, möglicherweise mehr.',
    },
    // Blaettern statt Kuerzen (REQ-OPS-032/033, T-M8.19b) — die zwei Texte,
    // die in JEDER geblaetterten Liste gleich lauten.
    pagination: {
      liveFirstPageOnly: 'Laufend aktualisiert wird nur die erste Seite.',
      loadFailed:        'Nachladen fehlgeschlagen.',
    },
  },

  status: {
    online:   'Online',
    offline:  'Offline',
    printing: 'Druckt',
    error:    'Fehler',
    ready:    'Bereit',
    pending:  'Ausstehend',
    done:     'Fertig',
    // Der Zustellstatus `completed` (REQ-DM-040) — «bestätigt zugestellt»
    // nach REQ-LC-040. Das Wort ist zitiert und nicht gewählt: es trägt die
    // Zustellung OHNE Druck mit (Bildschirm-Kanal, abbestellter Druck,
    // REQ-LC-043/044), für die «Gedruckt» eine Falschaussage wäre. Die eine
    // Marke für alle vier Zustell-Fundstellen (REQ-OPS-059 Präz. 1 (c)).
    completed: 'Zugestellt',
    failed:   'Fehlgeschlagen',
    expired:  'Abgelaufen',
  },

  role: {
    admin:    'Administrator',
    user:     'Benutzer',
  },

  auth: {
    email:              'E-Mail-Adresse',
    password:           'Passwort',
    passwordNew:        'Neues Passwort',
    passwordNewLabel:   'Neues Passwort *',
    passwordConfirm:    'Passwort bestätigen',
    passwordConfirmLabel:'Passwort bestätigen *',
    passwordMinHint:    'Mindestens 8 Zeichen',
    passwordRepeat:     'Passwort wiederholen',
    passwordMismatch:   'Passwörter stimmen nicht überein.',
    passwordTooWeak:    'Das Passwort ist zu schwach (mindestens 8 Zeichen).',
    passwordSave:       'Passwort speichern',
    passwordSaved:      'Passwort gespeichert!',
    passwordSavedHint:  'Ihr Passwort wurde erfolgreich geändert. Sie werden automatisch weitergeleitet …',
    toDashboard:        'Jetzt zum Dashboard',
    linkInvalid:        'Link ungültig',
    linkInvalidHint:    'Dieser Link ist abgelaufen oder wurde bereits verwendet. Bitte fordern Sie einen neuen Link an.',
    toLogin:            'Zum Login',
    setNewPassword:     'Neues Passwort festlegen',
    setNewPasswordHint: 'Geben Sie Ihr neues Passwort ein für',
    welcomeBack:        'Willkommen zurück',
    welcomeHint:        'Melden Sie sich mit Ihrem Konto an.',
    login:              'Anmelden',
    loggingIn:          'Anmelden …',
    logout:             'Abmelden',
    forgotPassword:     'Passwort vergessen?',
    resetPassword:      'Passwort zurücksetzen',
    resetSent:          'E-Mail gesendet. Bitte prüfen Sie Ihren Posteingang.',
    backToLogin:        'Zurück zur Anmeldung',
    sessionExpired:     'Ihre Sitzung ist abgelaufen (12 Stunden). Bitte erneut anmelden.',
    footer:             'Payfix AG · Druckmanagement-System · v1.0',
    strength: {
      weak:      'Schwach',
      medium:    'Mittel',
      strong:    'Stark',
      veryStrong:'Sehr stark',
    },
    errors: {
      invalidEmail:    'Ungültige E-Mail-Adresse.',
      wrongPassword:   'Falsches Passwort.',
      userNotFound:    'Kein Benutzer mit dieser E-Mail gefunden.',
      tooManyRequests: 'Zu viele Versuche. Bitte warten.',
      generic:         'Anmeldung fehlgeschlagen. Bitte erneut versuchen.',
      occurred:        'Ein Fehler ist aufgetreten.',
    },
  },

  // ── Die Annahme einer Einladung (T-M30.6, REQ-SEC-030) ───────────────────
  // ⚠ DREI ABWEISUNGEN, EIN TEXT: `errInvalid` traegt unbekanntes Geheimnis,
  // verbrauchte Einladung UND die abgelaufene bei falschem Geheimnis
  // (REQ-SEC-030 (g)) — sie sind serverseitig buchstabengleich und bleiben es
  // hier. `errExpired` ist die EINE benannte Ausnahme (REQ-SEC-030 (d)): sie
  // darf den Ablauf nennen, weil das Geheimnis stimmt.
  invitation: {
    title:        'Einladung annehmen',
    subtitle:     'Setzen Sie Ihr Passwort, um Ihr Konto einzurichten.',
    submit:       'Konto einrichten',
    working:      'Konto wird eingerichtet …',
    successTitle: 'Ihr Konto ist eingerichtet',
    successHint:  'Sie werden angemeldet und weitergeleitet …',
    errInvalid:   'Diese Einladung ist nicht gültig. Bitte fordern Sie eine neue Einladung an.',
    errExpired:   'Diese Einladung ist abgelaufen. Bitte fordern Sie eine neue Einladung an.',
    errExists:    'Zu dieser Adresse besteht bereits ein Konto. Bitte melden Sie sich mit Ihrem bestehenden Passwort an.',
    errFailed:    'Die Einladung konnte nicht angenommen werden. Es wurde nichts eingerichtet; bitte versuchen Sie es erneut.',
  },

  // ── Der Anmelde-Start (T-M21.2, REQ-OPS-052 (d)) ─────────────────────────
  // Die Fehleransicht statt des ewigen Ladebalkens. Angezeigt wird der CODE
  // (danach wird im Feld gesucht), nicht der englische Meldungstext von
  // Firebase. GENAU ZWEI Handlungen — mehr waeren eine Auswahl, die der Nutzer
  // nicht treffen kann.
  bootstrap: {
    errorTitle: 'Der Start ist gescheitert',
    errorHint:  'Die Anmeldung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut oder melden Sie sich neu an.',
    errorHintNoProfile: 'Zu diesem Konto besteht kein Benutzerprofil. Bitte wenden Sie sich an Ihren Administrator.',
    errorCode:  'Fehlercode: {code}',
    retry:      'Erneut versuchen',
    reLogin:    'Neu anmelden',
  },

  // ── Der sichtbare Verbindungszustand (T-M21.5, REQ-OPS-054) ───────────────
  // Der Hinweis NENNT die betroffenen Bereiche und nicht bloss «Fehler»; er
  // zeigt AUSDRÜCKLICH KEINEN Zeitpunkt — der Zeitpunkt der letzten empfangenen
  // Momentaufnahme wird nirgends geführt, und ein aus der Uhr gebildetes
  // «zuletzt aktualisiert» wäre eine erfundene Angabe (REQ-OPS-054 (b)).
  liveVerbindung: {
    title:     'Live-Aktualisierung unterbrochen',
    areas:     'Nicht mehr live: {areas}',
    hint:      'Die angezeigten Daten stammen aus der zuletzt empfangenen Aktualisierung und können veraltet sein. Sie werden erst wieder aktualisiert, wenn die Verbindung neu hergestellt ist.',
    reconnect: 'Erneut verbinden',
    quiet:     'Verbindung unterbrochen: {areas}',
    area: {
      jobs:         'Druckaufträge',
      printers:     'Drucker',
      printservers: 'Printserver',
      companies:    'Firmen',
      locations:    'Standorte',
      registers:    'Kassen',
      users:        'Benutzer',
      apiTokens:    'API-Tokens',
    },
  },

  fleet: {
    title:          'Flotte',
    subtitle:       'Druckserver je Standort – Zustand, Version und Warteschlangen live.',
    empty:          'Noch keine Druckserver',
    emptyHint:      'Sobald ein Druckserver eingerichtet ist, erscheint er hier.',
    noLocation:     'Ohne Standort',
    noServers:      'Keine Druckserver an diesem Standort',
    noPrinters:     'Keine Drucker',
    // ── „n Drucker warten auf Zuweisung" (T-M33.4, REQ-DM-072 (i)/(i1)) ──
    // ⚠ `text` ist die EINZIGE Nachricht dieses Woerterbuchs mit PLURALFORMEN
    // (vue-i18n: Einzahl | Mehrzahl, getrennt durch `|`). Sie wird mit der ZAHL
    // als zweitem Argument aufgerufen — `$t(key, n)`, nicht `{ count: n }` —,
    // sonst steht die Einzahl auch bei dreissig Druckern da. Die Zahl selbst
    // kommt aus `countUnassignedPrinters` und wird nirgends von Hand gefuehrt.
    unassignedPrinters: {
      text:   'Ein Drucker wartet auf Zuweisung | {count} Drucker warten auf Zuweisung',
      hint:   'Diese Drucker wurden über die Schnittstelle angelegt und keinem Druckserver zugewiesen. Sie erscheinen in keiner Gruppe dieser Ansicht und nehmen erst Aufträge an, wenn ein Druckserver zugewiesen ist.',
      action: 'In der Druckerliste zuweisen',
    },
    locationOffline:'Standort offline',
    serverCount:    '{n} Druckserver',
    version:        'Version',
    versionUnknown: 'Unbekannt',
    versionOutlier: 'Abweichend',
    versionOutlierHint: 'Weicht von der Flottenversion v{version} ab.',
    lastPing:       'Letztes Lebenszeichen',
    pending:        '{n} wartend',
    queueEmpty:     'Keine wartenden Aufträge',
    pendingAtLeast: 'Mindestens {n} wartend',
    queueUnknown:   'Warteschlange unbekannt',
    queueUnknownHint: 'Die Warteschlange konnte nicht gezählt werden. Das heisst nicht, dass sie leer ist.',
    // REQ-LC-015: zurückgehaltene Arbeitsbons sind kein Stau.
    queueHeldHeading: 'Zurückgehalten ({n})',
    queueHeldHint:    'Diese Aufträge werden erst gedruckt, wenn die Küche sie auf «Abholbereit» setzt. Sie haben deshalb keine Position in der Warteschlange.',
    queueNoneWaiting: 'Nichts wartet auf den Drucker',
    time: {
      never:        'Nie',
      justNow:      'Gerade eben',
      minutes:      'Vor {n} Min.',
      hours:        'Vor {n} Std.',
      days:         'Vor {n} Tagen',
    },
  },

  dashboard: {
    title:          'Dashboard',
    welcome:        'Willkommen',
    totalJobs:      'Aufträge gesamt',
    totalPrinters:  'Drucker gesamt',
    onlinePrinters: 'Drucker online',
    printservers:   'Printserver',
    recentJobs:     'Letzte Druckaufträge',
    noJobs:         'Keine Druckaufträge vorhanden.',
    // Die gesondert ausgewiesene, benannte Menge (REQ-LC-015).
    heldJobs:       'Zurückgehalten',
    heldJobsHint:   'Diese Arbeitsbons werden erst gedruckt, wenn die Küche sie auf «Abholbereit» setzt. Sie warten nicht auf den Drucker und sind kein Stau.',
  },

  printers: {
    title:         'Drucker',
    subtitle:      'Alle angeschlossenen Drucker dieser Firma',
    add:           'Drucker hinzufügen',
    empty:         'Noch keine Drucker angelegt',
    emptyHint:     'Fügen Sie den ersten Drucker dieser Firma hinzu.',
    number:        'Nr.',
    name:          'Bezeichnung',
    type:          'Typ',
    printserver:   'Printserver',
    ipAddress:     'IP-Adresse',
    pendingBons:   'Offene Bons',
    deleteTitle:   'Drucker löschen?',
    deleteConfirm: 'Möchten Sie {name} wirklich löschen?',
    new:           'Neuer Drucker',
    edit:          'Bearbeiten',
    openKitchen:      'Kitchen TV öffnen',
    openAbholscreen:  'Abholscreen öffnen',
    openFastline:     'Fastline öffnen',
    // BERICHTIGT AM 2026-08-17 (T-M8.19b, REQ-OPS-032 neu gefasst): der
    // Schluessel bleibt, sein Wortlaut wird berichtigt statt geloescht. Bis
    // dahin sagte er „die Liste ist gekuerzt, weitere Drucker sind hier nicht
    // sichtbar" — eine Sackgasse. Die 100 sind ab jetzt die SEITENgroesse.
    limitReached:     'Es sind weitere Drucker dieser Firma vorhanden: geladen wird eine Seite mit {count} Einträgen — weitere laden.',
    loadMore:         'Weitere {count} Drucker laden',
    // Kurzform fuer das Nachladen IM Auswahlkontext (Drucker-Dropdown der
    // Auftragsliste): dort ist kein Platz fuer die Seitengroesse.
    loadMoreShort:    'Weitere Drucker laden …',
    loadedCount:      '{count} Drucker geladen',
    endOfList:        'Ende der Liste – alle Drucker sind geladen.',
    sections: {
      basic:       'Grunddaten',
      abholscreen: 'Abholscreen Einstellungen',
      kitchenTv:   'Kitchen TV Einstellungen',
      alarm:       'Alarmierung',
      status:      'Zustand',
      screenAccess: 'Anzeige-Schluessel',
    },
    fields: {
      outputType:        'Ausgabeart',
      outputPrint:       'Drucker',
      outputKitchenTv:   'Kitchen TV / Bildschirm',
      outputPrintHint:   'Physischer ESC/POS-Drucker mit Adresse und Modelltyp.',
      outputKitchenTvHint: 'Bildschirm-Kanal ohne Druckserver, Adresse oder Modelltyp.',
      port:              'Port',
      abholscreenEnabled: 'Abholscreen aktiv',
      abholscreenEnabledHint: 'Zeigt abholbereite Bestellnummern auf dem Abholscreen an.',
      displayDurationHint: 'Anzeigedauer abholbereiter Bestellungen, 5 bis 600 Sekunden (Standard 60 Sekunden).',
      // Abschaltung des selbsttaetigen Erledigens (REQ-SC-081, T-M12.20). Der
      // Hinweis NENNT die Vier-Stunden-Grenze: `completestaleorders` raeumt
      // trotzdem ab (REQ-SC-015). Wer die Anzeige abschaltet, schaltet nicht
      // den Verfall ab, und das muss der Betreiber lesen koennen.
      autoCompleteDisabled:     'Selbsttaetiges Erledigen abschalten',
      autoCompleteDisabledHint: 'Abholbereite Bestellungen bleiben stehen, bis sie von Hand abgeschlossen werden — die Anzeigedauer erledigt sie dann nicht mehr. Vier Stunden nach Eingang werden sie trotzdem automatisch erledigt; diese Bereinigung laesst sich nicht abschalten.',
      maxItems:          'Max. angezeigte Nummern',
      maxItemsUnit:      'Nummern',
      maxItemsHint:      'Obergrenze gleichzeitig angezeigter Nummern (0 = unbegrenzt).',
      screenKeyHint:       'Der Anzeige-Schluessel meldet einen Bildschirm (Kitchen TV, Abholscreen, Fastline) an. Es wird nur der Hash gespeichert; der Klartext ist danach nicht mehr abrufbar.',
      screenKeySaveFirst:  'Bitte speichern Sie den Kanal zuerst, danach koennen Sie einen Anzeige-Schluessel setzen.',
      screenKeySet:        'Anzeige-Schluessel gesetzt',
      screenKeyNotSet:     'Kein Anzeige-Schluessel gesetzt',
      screenKeyPlaceholder:'Schluessel eingeben oder generieren',
      screenKeyGenerate:   'Generieren',
      screenKeySave:       'Schluessel setzen',
      screenKeyRotate:     'Schluessel rotieren',
      screenKeyOnce:       'Dieser Schluessel wird nur EINMAL angezeigt. Bitte jetzt sicher notieren.',
      // Die Schluesselpflicht je Kanal (REQ-SEC-024, REQ-DM-063; T-M18.9).
      // ⚠ DER HINWEIS ZUM ABGESCHALTETEN SCHALTER SAGT DIE FOLGE ALS TATSACHE —
      // nicht im Konjunktiv und nicht als Abmahnung: der Entscheid des
      // Auftraggebers ist final (REQ-SEC-024 (j)), die Bedienstelle darf ihn nur
      // nicht als folgenlos darstellen. Die DRUCKFOLGE steht in einem eigenen
      // Schluessel, weil sie nur an einer Kanalart eintreten kann.
      screenKeyRequired:        'Anzeige-Schluessel verlangen',
      screenKeyRequiredHint:    'Ein Bildschirm meldet sich an diesem Kanal mit dem Anzeige-Schluessel an. Ohne ihn bekommt er keinen Zugang.',
      screenKeyRequiredOffHint: 'Dieser Kanal ist ohne Anzeige-Schluessel offen: Wer die Adresse des Bildschirms kennt, liest die Auftraege dieses Kanals und setzt ihren Bearbeitungsstatus. Der Zugriff bleibt auf diesen Kanal und diese Firma begrenzt.',
      screenKeyRequiredOffPrintHint: 'An diesem Kanal loest das auch einen Druck aus: Wer eine Bestellung auf «Abholbereit» setzt, gibt damit den zurueckgehaltenen Arbeitsbon frei, und er wird gedruckt.',
      alarmEnabled:      'Alarmierung aktiv',
      alarmEnabledHint:  'Benachrichtigt bei Druckerproblemen (offline, Fehler).',
      alarmMuted:        'Vollständig stummschalten',
      alarmMutedHint:    'Unterdrückt alle Alarme dieses Druckers.',
      alarmStages:       'Alarmierte Stufen',
      stage_offline:     'Offline',
      stage_paperLow:    'Papier fast leer',
      stage_error:       'Fehler',
      stage_coverOpen:   'Deckel offen',
      // Stufe Papierende (T-M42.3, REQ-PS-023c) und Kennzeichnung unwirksamer
      // Stufen je Modelltyp (REQ-PS-023a Praez. 1 (a) / Praez. 3).
      stage_paperOut:    'Papier leer',
      stageIneffective:  'unwirksam',
      stageIneffectiveTitle: 'Der Modelltyp {model} meldet diesen Zustand nicht. Die Stufe lässt sich setzen, löst an diesem Drucker aber nie einen Alarm aus.',
      stagesIneffectiveHint: 'Mit «unwirksam» gekennzeichnete Stufen meldet der Modelltyp {model} nicht: Sie lassen sich setzen, lösen an diesem Drucker aber nie einen Alarm aus.',
      // T-M42.10 Teil (b): die gesetzten Stufen wuerden mangels Einrichtung
      // am Mandanten nie versendet (Regel: utils/alarmEinrichtung.ts).
      alarmNotSetUpTypeDisabled: 'Alarmierung nicht eingerichtet: In der Alarmzentrale der Firma ist «Druckerstörung» ausgeschaltet. Die hier gesetzten Stufen werden nie versendet.',
      alarmNotSetUpNoRecipients: 'Alarmierung nicht eingerichtet: In der Alarmzentrale der Firma ist kein Empfänger hinterlegt. Die hier gesetzten Stufen werden nie versendet.',
      printerId:         'Printer ID',
      printerIdPlaceholder: 'z. B. 3324',
      printerIdHint:     'Die Drucker-Kennung aus dem Payfix-Portal — genau der Wert, den die Kasse als printer_id sendet. Keine frei gewählte Hausnummer: ohne die richtige Kennung erreicht kein Bon diesen Kanal.',
      designation:       'Bezeichnung',
      printerType:       'Drucker Typ',
      printerServer:     'Printserver',
      ipAddress:         'IP-Adresse',
      sameAddressHint:   'Gleiche Adresse wie «{name}». Beide Kanäle drucken nacheinander auf demselben Gerät.',
      company:           'Firma',
      range:             'Von / Bis',
      rangeFrom:         'Von',
      rangeTo:           'Bis',
      // NEU 2026-09-17 (T-M43.3, REQ-DM-073 / REQ-LC-048): was ein Tischbereich
      // bewirkt. NACHGEFUEHRT 2026-09-24 (T-M44.3, REQ-DM-073 Praez. 1 (c),
      // REQ-LC-048 Praez. 2): der Bereich gilt fuer BEIDE Belegarten. Vier
      // Aussagen und keine fuenfte — (1) gefiltert werden Arbeitsbons UND
      // Quittungen, (2) auch an Kitchen TV, Abholscreen und Fastline, (3) Belege
      // ohne Tischnummer (Tagesabschluesse, Mitarbeiterabrechnungen) immer,
      // (4) kein Bereich = kein Filter. Ausdruecklich KEINE Zusage ueber den
      // Zeitpunkt der Wirkung und keine Erklaerung des Antwortrumpfs. Die
      // Aussage je Sprache haelt `test/tischbereichTypUndHinweis.test.ts`.
      // *Bis zum 2026-09-24 hiess die Ausnahme „ohne Tischnummer und Kassenbons
      // immer" — aufgehoben durch Entscheid 6 des Auftraggebers.*
      tableRangesHint:   'Sind Bereiche gesetzt, erhält dieser Kanal nur Arbeitsbons und Quittungen, deren Tischnummer in einem der Bereiche liegt. Das gilt auch für Kitchen TV, Abholscreen und Fastline. Belege ohne Tischnummer – darunter Tagesabschlüsse und Mitarbeiterabrechnungen – erhält dieser Kanal immer. Ist kein Bereich gesetzt, erhält er alles.',
      qrCode:            'QR Code drucken',
      qrCodeHint:        'Fügt einen QR-Code auf dem Bon hinzu. Er ist zugleich die Voraussetzung dafür, dass Aufträge auf dem Abholscreen dieses Druckers erscheinen.',
      // Ausschluss Bon-QR-Druck ↔ zugeschaltete Kitchen-TV-Ansicht (REQ-SC-084 (a))
      qrCodeOffByKitchenTv: 'Der Bon-QR-Druck bleibt aus, solange die Kitchen-TV-Ansicht zugeschaltet ist — beide sind am selben Drucker nie gleichzeitig aktiv. Wer ihn hier einschaltet, schaltet damit die Kitchen-TV-Ansicht ab.',
      qrCodeOffByU220: 'Der TM-U220 druckt keinen QR-Code. Der Schalter ist an diesem Modell gesperrt und ohne Wirkung.',
      showName:          'Druckername anzeigen',
      colorWorking:      'Farbe in Arbeit',
      colorReady:        'Farbe in Abholbereit',
      displayDuration:   'Anzeigedauer',
      preview:           'Vorschau',
      kitchenTvEnabled:  'Kitchen TV',
      // Zuschaltung der Kitchen-TV-Ansicht an einem Drucker (REQ-SC-084)
      kitchenTvEnabledHint: 'Zeigt die Bestellungen dieses Druckers zusätzlich auf einem Kitchen-TV-Bildschirm. Der Drucker bleibt dabei ein vollwertiger Drucker und druckt weiter. Beim Einschalten wird der Bon-QR-Druck ausgeschaltet.',
      // ⚠ `kitchenTvLight` und `kitchenTvLightHint` standen bis zum 2026-08-22
      // hier — die Beschriftung des Light-Schalters. ENTFALLEN mit T-M25.5 in
      // allen sechs Sprachen, weil das Bedienelement entfallen ist
      // (REQ-SC-106 (1), REQ-PS-023a): der Light-Modus folgt seit T-M25.1 der
      // Adresse `/kitchen/:printerId/light`. Der ANZEIGENAME des Modus steht ab
      // jetzt unter `printers.screenMode.light` (eigene Schluessel des Portals,
      // REQ-SC-106 (2)). *Damit ist zugleich Fund (2) aus
      // `test/i18nDeutscherWortlaut.test.ts` gegenstandslos — der deutsche
      // Hinweis beschrieb die Kachelansicht, vier Uebersetzungen ein
      // Farbschema; der Schluessel besteht nicht mehr.*
      autoStartTimer:    'Timer automatisch starten',
      autoStartTimerHint:'Startet den Timer automatisch beim Eingang einer Bestellung',
      // Abbestellter Druck (REQ-SC-077, REQ-LC-043). Der Hinweis sagt beides,
      // was der Schalter tut und was er NICHT tut: Kassenbons bleiben auf
      // Papier, und an einem reinen Bildschirm-Kanal faellt die Wirkung mit dem
      // Bestehenden zusammen (REQ-SC-077 Praez. 1 — verschweigen darf er das
      // nicht, eine zweite Wirkung erfinden auch nicht).
      disablePrintingWhenKitchenTv:     'Arbeitsbons nicht drucken',
      disablePrintingWhenKitchenTvHint: 'Arbeitsbons dieses Kanals werden nicht mehr gedruckt, sondern nur noch auf dem Kitchen TV angezeigt. Sie gelten sofort als zugestellt und erscheinen in der Auftragsliste mit dem Vermerk «ohne Druck zugestellt». Kassenbons werden weiterhin gedruckt. An einem reinen Bildschirm-Kanal bleibt die Einstellung ohne Wirkung, weil dort ohnehin nie gedruckt wird.',
      // `fastline` bleibt: es beschriftet die KARTE der Fastline-Adresse.
      // ⚠ `fastlineHint` stand bis zum 2026-08-22 hier — der Hinweis unter dem
      // Fastline-Schalter. ENTFALLEN mit T-M25.5 in allen sechs Sprachen
      // (REQ-SC-106 (1)/(4), Tims Punkt 4c): der Schalter lag unter
      // „Abholscreen Einstellungen" und steuerte seit T-M25.4 nichts mehr.
      fastline:          'Fastline',
      rangeRemove:       'Range {n} entfernen',
      abholscreenUrl:    'Abholscreen URL',
      kitchenTvUrl:      'Kitchen TV URL',
      // Die vierte Adresse (REQ-SC-053 in der Fassung vom 2026-08-21,
      // REQ-SC-103 (1)): der Light-Modus liegt INNERHALB von `/kitchen/`.
      // ⚠ DER SCHLUESSEL HEISST `kitchenTvUrlLight` UND NICHT
      // `kitchenTvLightUrl`, und das ist kein Schoenheitsfehler: der Waechter
      // `test/modusrechnungOberflaeche.test.ts` erhebt die Lesestellen des
      // KANALFELDES `kitchenTvLight` als Zeichenkette. Ein i18n-Schluessel mit
      // demselben Praefix waere dort ein Falschtreffer in sechs Sprachdateien —
      // und ein Waechter, der Falschtreffer sammelt, wird bald erweitert statt
      // gelesen. Der Text beschriftet eine ADRESSE und hat mit dem Feld nichts
      // zu tun.
      kitchenTvUrlLight: 'Kitchen TV Light URL',
      fastlineUrl:       'Fastline URL',
    },
    // ── DER AKTIVE BILDSCHIRM-MODUS, ANGEZEIGT STATT EINGESTELLT ─────────────
    // (REQ-SC-106 (2), T-M25.5). EIGENE Schluessel des Portals und ausdruecklich
    // nicht die des Bildschirms (`screen.modeName*`): dort heisst der normale
    // Modus im Satz „An diesem Kanal läuft zurzeit «Kitchen TV»" schlicht
    // „Kitchen TV", hier verlangt REQ-SC-106 (2) wörtlich „Kitchen TV normal".
    // Die drei Modusnamen sind Produktnamen und stehen in allen sechs Sprachen
    // gleich (dieselbe Linie wie REQ-SC-076 Präz. 2 Nachtrag (vi) und
    // REQ-SC-097); die FELDWERTE bleiben technisch-englisch (`normal`, `light`,
    // `fastline` — REQ-OV-002, REQ-DM-068 (1)).
    // ⚠ Die vier Wert-Schlüssel tragen das Präfix `mode_`; der Grund steht bei
    // ihrer Bildung in `views/PrinterDetailView.vue` (Feldnamen-Wächter,
    // OP-119) und ist keine Geschmacksfrage.
    screenMode: {
      label:    'Aktiver Modus',
      hint:     'Zeigt, welcher Bildschirm diesen Kanal gerade führt. Der Modus wird am Bildschirm selbst übernommen, nicht hier: wer eine der drei Adressen öffnet, bestätigt dort den Wechsel und deaktiviert damit den bisherigen Modus.',
      mode_normal:   'Kitchen TV normal',
      mode_light:    'Kitchen TV Light',
      mode_fastline: 'Fastline',
      mode_none:     'kein Modus aktiv',
    },
    kitchenTvInactive: 'Kitchen TV ist deaktiviert. Aktivieren Sie es oben, um die Einstellungen anzupassen.',
    // Ausgabeart `kitchenTv`: die Ansicht laeuft dort immer (REQ-SC-084 (b))
    kitchenTvAlwaysOn: 'Dieser Kanal ist ein Bildschirm-Kanal: die Kitchen-TV-Ansicht läuft hier immer und lässt sich nicht abschalten.',
    // Druckerzustand: grob (status.*) plus feine Kennungen (REQ-PS-020a/021).
    // Werte bleiben technisch-englisch in Firestore, hier nur die Anzeige.
    status: {
      title:       'Aktueller Zustand',
      noDetail:    'Keine Auffälligkeiten',
      // T-M17.9 / REQ-PS-027 Praez. 1 (d): `statusUpdatedAt` ist das Alter der
      // letzten Zustands-AENDERUNG, nicht das Alter der Auskunft. Die frühere
      // Beschriftung «Zuletzt gemeldet» war deshalb falsch. Zwei Zeiten, zwei
      // Sätze — «zuletzt gemeldet vor …» gehört an das Lebenszeichen des
      // Druckservers (siehe `stale` unten).
      updatedAt:     'Zustand unverändert seit',
      updatedAtHint: 'Der Zeitpunkt der letzten Zustands-Änderung — nicht der Zeitpunkt der letzten Meldung. Der Druckserver schreibt diesen Wert nur, wenn sich der Zustand ändert; ein dauerhaft fehlerfreier Drucker trägt hier deshalb einen alten Zeitpunkt.',
      never:         'Noch keine Zustandsmeldung',
      // Veralterung der Auskunft (REQ-PS-027): tritt NEBEN den Zustand
      stale: {
        withAge:    'Veraltet — zuletzt gemeldet vor {age}',
        unknownAge: 'Veraltet — unbekanntes Alter',
        age: {
          lessThanMinute: 'weniger als einer Minute',
          minute:  'einer Minute',
          minutes: '{n} Minuten',
          hour:    'einer Stunde',
          hours:   '{n} Stunden',
          day:     'einem Tag',
          days:    '{n} Tagen',
        },
        reason: {
          noPrintserver: 'Diesem Drucker ist kein Druckserver zugeordnet. Den Zustand schreibt ausschliesslich der Druckserver — ohne ihn bleibt der zuletzt geschriebene Wert stehen, beliebig lange.',
          noPing:        'Der zuständige Druckserver hat noch kein Lebenszeichen geschrieben. Wie alt der angezeigte Zustand ist, lässt sich deshalb nicht sagen.',
          serverOffline: 'Der zuständige Druckserver ist offline. Er kann den Zustand dieses Druckers nicht mehr melden; angezeigt wird der zuletzt geschriebene Wert.',
          pingTooOld:    'Das letzte Lebenszeichen des zuständigen Druckservers liegt über der Frist von 90 Sekunden (dreimal der Takt von 30 Sekunden). Der angezeigte Zustand ist der zuletzt geschriebene und muss nicht mehr zutreffen.',
        },
      },
      sourceLabel: 'Quelle',
      levelLabel:  'Detailtiefe',
      levelHint:   'Wie fein dieses Druckermodell Auskunft geben kann.',
      detail: {
        offline:     'Nicht erreichbar',
        coverOpen:   'Deckel offen',
        paperOut:    'Papier leer',
        cutterError: 'Fehler der Schneideeinheit',
        error:       'Druckerfehler',
        notResponding: 'Antwortet nicht',
        paperLow:    'Papier bald leer',
      },
      source: {
        asb:        'Selbstmeldung des Druckers',
        poll:       'Aktive Abfrage',
        jobResult:  'Aus dem Druckergebnis abgeleitet',
        connection: 'Verbindung unterbrochen',
      },
      level: {
        full:  'Vollständig',
        basic: 'Eingeschränkt',
        none:  'Keine Statusrückmeldung',
      },
    },
    archived:     'Archiviert',
    archivedHint: 'Archivierte Drucker nehmen keine Aufträge mehr an.',
    incomplete:     'Unvollständig',
    // ⚠ WORTLAUT BERICHTIGT AM 2026-09-07 (T-M33.3, Kriterium 6; REQ-DM-072 (h)).
    // Bis dahin stand hier: „Diesem Drucker fehlt der Zieldruckserver. Aufträge
    // werden angenommen, aber von keinem Druckserver ausgeliefert." Das traf bis
    // T-M8.3 (2026-07-22) zu und trifft seither NICHT mehr zu: der
    // Auftragseingang weist einen Auftrag an einen `print`-Drucker ohne
    // auflösbaren Zieldruckserver mit 400 ab, es entsteht kein Dokument. Ein
    // ausgegebener Text ist Verhalten — deshalb berichtigt und nicht bloss
    // vermerkt. Die fünf Übersetzungen sind im selben Zug nachgezogen.
    incompleteHint: 'Diesem Drucker fehlt der Zieldruckserver. Er nimmt erst Aufträge an, wenn ein Druckserver zugewiesen ist; bis dahin werden Aufträge an ihn abgewiesen.',
    // ── Filter, Schnellzuweisung und Hinweiskasten (T-M33.3, REQ-DM-072 (i)) ──
    // Seit dem 2026-09-07 legt die REST-API `print`-Drucker ohne Zieldruckserver
    // an; die Zuweisung geschieht hier. Die Zahl in `filter.unassigned` wird
    // ABGELEITET (`countUnassignedPrinters`) und nie von Hand geführt.
    filter: {
      all:            'Alle',
      unassigned:     'Ohne Druckserver ({count})',
      noneUnassigned: 'Jedem Drucker ist ein Druckserver zugewiesen.',
    },
    quickAssign: {
      label:       'Druckserver zuweisen',
      placeholder: 'Druckserver zuweisen …',
      saving:      'Wird zugewiesen …',
      failed:      'Die Zuweisung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
      noServers:   'Für diese Firma ist kein Druckserver erfasst.',
    },
    unassignedNotice: {
      title: 'Kein Druckserver zugewiesen',
      body:  'Dieser Drucker wurde über die Schnittstelle angelegt und nimmt erst Aufträge an, wenn ein Druckserver zugewiesen ist. Wählen Sie unten einen Druckserver und speichern Sie.',
    },
    validation: {
      nameRequired:         'Bitte geben Sie eine Bezeichnung ein.',
      numberRequired:       'Bitte geben Sie die Printer ID aus dem Payfix-Portal ein.',
      // NEU am 2026-09-18 (T-M41.8, REQ-DM-036 Praez. 4 (ix)): die Kennung ist
      // seit dem Sperrdokument `printerKeys/{payfixPrinterId}` zugleich eine
      // DOKUMENT-KENNUNG, und nicht jede Zeichenkette kann eine sein. Ohne
      // diese Abweisung gäbe es genau zwei Ausgänge — ein technischer Fehler
      // beim Speichern oder ein Drucker OHNE die Garantie, die die Sammlung
      // verspricht. Die Cloud antwortet an derselben Stelle mit 400.
      //
      // ⚠ DIE LEERE KENNUNG GEHÖRT NICHT HIERHER: sie ist der bestehende
      // Pflichtfeldfehler `numberRequired` — zwei Meldungen für dieselbe Lage
      // wären eine zu viel.
      payfixPrinterIdInvalid: 'Diese Printer ID kann nicht gespeichert werden. Nicht zulässig sind der Schrägstrich, die Werte «.» und «..», Kennungen der Form «__…__» sowie mehr als 1500 Byte. Bitte tragen Sie die für diesen Drucker im Payfix-Portal hinterlegte Kennung ein.',
      // Die Faelle der Kennungs-Kollision (REQ-DM-036 Praez. 1 und 2, T-M29.4).
      //
      // ⚠ SEIT DEM 2026-09-01 SIND ES VIER STATT DREI (Praez. 3, T-M30.11) —
      // berichtigt statt geloescht (REQ-OPS-036 Praez. 6). Der frühere
      // Kommentar lautete „Die drei Faelle … Welcher gilt, entscheidet
      // `payfixPrinterIdConflictMessage`." BEIDES trifft nicht mehr zu: der
      // vierte Fall ist (b′), und entschieden wird in
      // `payfixPrinterIdMeldung` — anhand der ANTWORT DES SERVERS
      // (`checkpayfixprinterid`, REQ-SEC-034), nicht mehr anhand eines selbst
      // gelesenen `companies`-Dokuments.
      //
      // (a) derselbe Mandant — die Firma wird genannt, ohne Sonderweg.
      payfixPrinterIdTaken: 'Die Printer ID {id} ist bereits am Drucker «{name}» der Firma «{company}» vergeben. Jede Kennung darf nur einmal vorkommen — sonst landet der Bon am falschen Kanal. Bitte tragen Sie die für diesen Drucker im Payfix-Portal hinterlegte Kennung ein.',
      // (b) ein fremder Mandant — der Bediener erfährt, dass er diesen Drucker
      // nicht sehen kann und wen er zu fragen hat. KEIN Weg dorthin
      // (REQ-SEC-011): die Meldung informiert, sie handelt nicht.
      payfixPrinterIdTakenOtherCompany: 'Die Printer ID {id} ist bereits am Drucker «{name}» der Firma «{company}» vergeben — also ausserhalb der hier gewählten Firma, und dieser Drucker ist für Sie nicht einsehbar. Jede Kennung darf nur einmal vorkommen — sonst landet der Bon am falschen Kanal. Bitte wenden Sie sich an die Verantwortlichen von «{company}» oder tragen Sie die für diesen Drucker im Payfix-Portal hinterlegte Kennung ein.',
      // (b′) ein fremder Mandant, den der Betrachter NICHT sehen darf — die
      // Firma wird ausdrücklich NICHT genannt (weder Name noch Kennung), und
      // der Handlungssatz führt zum Payfix-Support. ER IST EIN ANDERER ALS IN
      // (c): dort ist niemand zu fragen, hier schon.
      payfixPrinterIdTakenOtherCompanyUnnamed: 'Die Printer ID {id} ist bereits in einer anderen Firma vergeben. Welche Firma das ist, wird hier nicht angezeigt — sie liegt ausserhalb Ihres Zugriffs. Jede Kennung darf nur einmal vorkommen — sonst landet der Bon am falschen Kanal. Bitte wenden Sie sich an den Payfix-Support oder tragen Sie die für diesen Drucker im Payfix-Portal hinterlegte Kennung ein.',
      // (c) verwaiste Kennung — der Zustand wird benannt, die Ursache NICHT
      // behauptet (Praez. 2 (ii)): der Text sagt nirgends, dass eine Firma
      // gelöscht wurde. Die Wurzel ist REQ-DM-069 und hier nur benannt.
      payfixPrinterIdTakenOrphaned: 'Die Printer ID {id} ist bereits am Drucker «{name}» vergeben, und dieser Drucker ist keiner lesbaren Firma zugeordnet — eine verwaiste Kennung. Sie bleibt dadurch systemweit belegt, obwohl kein Mandant dazu auffindbar ist. Bitte tragen Sie eine andere im Payfix-Portal hinterlegte Kennung ein und melden Sie die verwaiste Kennung dem Betrieb.',
      // DERSELBE Fall (c) ohne die Nennung des belegenden Druckers — der
      // Server liefert seinen Namen ohne Nenn-Berechtigung nicht
      // (REQ-SEC-034 (c)). Gleicher Zustand, gleicher Handlungssatz; es fehlt
      // allein die Nennung. Auch dieser Wortlaut behauptet KEINE Löschung.
      payfixPrinterIdTakenOrphanedUnnamed: 'Die Printer ID {id} ist bereits vergeben, und der belegende Drucker ist keiner lesbaren Firma zugeordnet — eine verwaiste Kennung. Sie bleibt dadurch systemweit belegt, obwohl kein Mandant dazu auffindbar ist. Bitte tragen Sie eine andere im Payfix-Portal hinterlegte Kennung ein und melden Sie die verwaiste Kennung dem Betrieb.',
      // KEINE Kollisionsmeldung, sondern ihr Ausfall: die Auskunft der Cloud
      // war nicht erreichbar. Ein Ausfall ist ausdrücklich kein „frei" —
      // gespeichert wird nichts (REQ-DM-035, REQ-SEC-034).
      payfixPrinterIdCheckFailed: 'Die Printer ID konnte nicht geprüft werden — die Auskunft ist zurzeit nicht erreichbar. Es wurde nichts gespeichert. Bitte versuchen Sie es in einem Moment erneut.',
      printserverRequired:  'Bitte wählen Sie einen Druckserver. Ohne Zieldruckserver wird der Auftrag nicht ausgeliefert.',
      modelTypeRequired:    'Bitte wählen Sie einen Modelltyp (Standard, U220 oder Sunmi).',
      ipAddressRequired:    'Bitte geben Sie die IP-Adresse oder den Hostnamen des Druckers ein. Ohne Adresse kann der Druckserver ihn weder ansteuern noch seinen Zustand abfragen.',
      printserverForbidden: 'Ein Bildschirm-Kanal darf keinen Druckserver haben.',
    },
    // Kein Bedienelement ohne Wirkung (REQ-SC-005 / REQ-PS-023a sinngemaess)
    warnings: {
      abholscreenNeedsQrCode:       'Der Abholscreen bleibt an diesem Drucker leer: ohne Bon-QR-Druck erscheint darauf kein Auftrag. Der gedruckte Bon-QR ist der Abholnachweis des Gasts. Ein später eingeschalteter Bon-QR-Druck wirkt nur auf neu eingehende Aufträge — bereits angelegte Aufträge erscheinen nicht nachträglich.',
      abholscreenNeedsQrCodeAction: 'Bon-QR-Druck einschalten',
      abholscreenNeedsKitchenTvAction: 'Kitchen-TV-Ansicht zuschalten',
      abholscreenNeedsQrCodeSave:   'Abholscreen aktiv, Bon-QR-Druck aus: dieser Abholscreen bleibt leer. Klicken Sie nochmals auf Speichern, um die Einstellung trotzdem so zu speichern.',
    },
    // Wirkungslose Kanaleinstellungen kenntlich machen (REQ-SC-081,
    // REQ-PS-023a sinngemaess).
    //
    // ⚠ HIER STANDEN BIS ZUM 2026-08-18 zwei weitere Schluessel,
    // `displayDurationNoEffect` und `displayDurationNoEffectHint` (T-M10.2,
    // Arbeitsannahme OP-71/Variante B): sie kennzeichneten die Anzeigedauer am
    // `print`-Kanal mit Bon-QR-Druck als wirkungslos. Berichtigt statt
    // geloescht (REQ-OPS-036 Praez. 6): der Scan erzeugt dort seit REQ-SC-092
    // (2) `ready`, die Anzeigedauer wirkt wieder, und die zwei Texte sind mit
    // T-M20.10 in allen sechs Sprachen entfallen.
    notices: {
      displayDurationDisabled:     'Ohne Wirkung: Erledigen ist abgeschaltet',
      displayDurationDisabledHint: 'Solange das selbsttaetige Erledigen abgeschaltet ist, laeuft nach dieser Dauer nichts ab. Der Wert bleibt gespeichert und wirkt wieder, sobald die Abschaltung zurueckgenommen wird.',
    },
  },

  printserver: {
    title:              'Printserver',
    subtitle:           'Verbundene Printserver dieser Firma',
    subtitleAllCompanies: 'Verbundene Printserver aller Firmen',
    subtitleOwnCompanies: 'Verbundene Printserver Ihrer Firmen',
    add:                'Printserver hinzufügen',
    empty:              'Noch keine Printserver angelegt',
    emptyHint:          'Fügen Sie den ersten Printserver hinzu.',
    name:               'Name',
    uuid:               'UUID',
    uuidCopy:           'UUID kopieren',
    uuidLabel:          'UUID (automatisch generiert)',
    uuidHint:           'Eine Bezeichnung für den Menschen, kein Konfigurationswert: der Daemon liest die UUID nicht. Für die Einrichtung gilt die Dokument-ID.',
    documentId:         'Dokument-ID',
    documentIdHint:     'Diese Kennung liest der Daemon als PRINTSERVER_ID aus seiner .env-Datei. Sie wird beim Anlegen vergeben und kann nicht geändert werden.',
    documentIdPending:  'Die Kennung entsteht erst mit dem Speichern.',
    ipAddress:          'IP-Adresse',
    // NEU AM 2026-10-27 (T-M53.3, REQ-DM-064 Präz. 7 (i)): die AnyDesk-ID des
    // Geräts und ihr EIGENER Hinweis, wenn sie fehlt. Er nennt beide Ursachen
    // und verspricht bewusst KEIN Erscheinen nach dem nächsten Neustart — an
    // einem Gerät ohne AnyDesk wäre das falsch (REQ-OPS-034 Präz. 3).
    anydeskId:          'AnyDesk-ID',
    anydeskIdMissing:   'Die AnyDesk-ID meldet der Druckserver beim Start. Fehlt sie, läuft auf dem Gerät entweder noch eine ältere Software, die sie nicht meldet, oder AnyDesk ist dort nicht installiert bzw. die ID ist nicht lesbar.',
    company:            'Firma',
    status:             'Status',
    connectedSince:     'Verbunden seit',
    lastContact:        'Letzter Kontakt',
    connectedMins:      '{n} Min. verbunden',
    connectedHrs:       '{h} Std. {m} Min. verbunden',
    lessThan1Min:       '< 1 Min.',
    lastContactSec:     'vor {n} Sek.',
    lastContactMin:     'vor {n} Min.',
    lastContactHr:      'vor {n} Std.',
    nodeVersion:        'Node.js Version',
    appVersion:         'App-Version',
    printerCount:       'Drucker verbunden',
    printerCountValue:  '{n}',
    printerCountAtLeast:'mindestens {n}',
    printerCountAtLeastHint: 'Die Druckerliste ist erst seitenweise geladen ({count} je Seite) — die Zahl ist eine Untergrenze. Zu diesem Druckserver können weitere Drucker gehören; weitere laden.',
    printerCountUnknownHint: 'Die Druckerliste liegt noch nicht vor. Die Zahl erscheint, sobald sie geladen ist.',
    runtimeFieldPending:'Dieses Feld meldet der Druckserver beim Statuswechsel (Start oder Stopp). Geräte mit älterer Software melden es noch nicht — der Wert erscheint nach dem nächsten Neustart.',
    updateAvailable:    'Update verfügbar: v{v}',
    restartControl:     'Neustart-Steuerung',
    restartManual:      'Manueller Neustart',
    restartHint:        'Sendet einen Neustart-Befehl an die Node.js-Applikation auf dem Raspberry Pi.',
    restartAfter:       'Neustart nach (Minuten)',
    restartNow:         'Jetzt neustarten',
    restarting:         'Neustart …',
    // ⚠ `restartSent` stand bis zum 2026-09-18 hier — „Neustart-Befehl
    // gesendet. Der Pi startet in Kürze neu." ENTFALLEN mit T-M41.9 in allen
    // sechs Sprachen, weil der Text eine Wirkung auf ein FREMDES GERÄT
    // behauptete, die niemand kannte: seine ganze Grundlage war der gelungene
    // Schreibvorgang eines Feldes in Firestore (REQ-OPS-034 Präz. 3,
    // REQ-RP-048 Festlegung 6). An seiner Stelle stehen seit T-M41.9 die
    // Schlüssel der QUITTUNG aus dem Live-Dokument (`restartRequested`,
    // `restartNotAcknowledged`, `restartExecuted`, `restartReconnected`) —
    // sie geben zwei Zeitpunkte wieder und fällen kein Urteil. Der Schlüssel
    // hatte seit T-M41.9 keinen Verwender mehr, und ein Schlüssel ohne
    // Verwender ist genau die Klasse, die M41 räumt (OP-148/OP-154/OP-78).
    // NICHT wieder aufnehmen.
    // NEU AM 2026-09-18 (T-M41.9, REQ-RP-048 Festlegung 6): die QUITTUNG aus dem
    // Live-Dokument tritt an die Stelle der Erfolgsmeldung nach dem Klick. Sie
    // sagt zwei Zeitpunkte und faellt kein Urteil — ein «erfolgreich» tragen die
    // Daten nicht (REQ-OPS-034 Praez. 3).
    restartRequested:        'Neustart angefordert am {t}',
    restartNotAcknowledged:  'Noch keine Quittung vom Gerät.',
    restartExecuted:         'Vom Gerät ausgeführt am {t}',
    restartReconnected:      'Wieder verbunden seit {t}',
    // NEU AM 2026-09-18 (T-M41.9, REQ-RP-048 Festlegung 7): das Intervall liest
    // der Launcher beim START — die Änderung wirkt deshalb nicht sofort.
    autoRestartDelayHint: 'Die Änderung wirkt ab dem nächsten Start des Launchers auf dem Gerät — wie die Neustart-Uhrzeit. 0 = kein Intervall.',
    autoRestart:        'Automatischer Neustart',
    autoRestartHint:    'Die App wird automatisch nach diesem Intervall neu gestartet. 0 = deaktiviert.',
    autoRestartDisabled:'Auto-Neustart ist deaktiviert.',
    autoRestartEnabled: 'App wird alle {n} Minuten neu gestartet.',
    connectionInfo:     'Verbindungsinfo',
    connectionHint:     'Der Raspberry Pi aktualisiert IP, Version und Status automatisch via Firestore-Heartbeat.',
    deleteTitle:        'Printserver löschen?',
    deleteConfirm:      'Möchten Sie {name} wirklich löschen?',
    cannotUndoFull:     'Möchten Sie „{name}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    new:                'Neuer Printserver',
    stammdaten:         'Stammdaten',
    assignCompany:      'Firma zuordnen',
    noCompany:          '— Keine Firma zugeordnet —',
    companyHint:        'Der Printserver erscheint nur für Benutzer dieser Firma.',
    companyPreset:      'Vorbelegt',
    companySearch:      'Firma suchen …',
    companySelect:      'Firma auswählen',
    companyNoMatch:     'Keine Firma gefunden.',
    // NEU AM 2026-09-28 (T-M45.6, REQ-DM-074 (2)/(5)): die Kaskade beim
    // Umhaengen und Loeschen eines Druckservers und die Sperre ohne Firma.
    cascadeTitle:       'Drucker verlieren ihren Druckserver',
    cascadeText:        'Diesem Druckserver zugewiesene Drucker ({count}): {names}. Sie verlieren die Zuweisung und nehmen keine Aufträge mehr an, bis ihnen ein Druckserver zugewiesen ist.',
    cascadeConfirm:     'Zuweisung entfernen und fortfahren',
    companyRequired:    'Bitte eine Firma zuordnen. Soll der Druckserver keiner Firma mehr gehören, löschen Sie ihn.',
    infoCard:           'Info',
    piSetup:            'Raspberry Pi Setup',
    piSetupHint:        'Tragen Sie diese Kennung in die .env-Datei des Raspberry Pi Daemons ein:',
    piSetupPending:     'Speichern Sie den Druckserver zuerst. Danach steht hier die Kennung, die in die .env-Datei des Raspberry Pi Daemons gehört.',
    settingsTitle:      'Alle konfigurierten Printserver – klicken zum Öffnen',
    settingsNoCompany:  '— Keine Firma —',
    settingsAddFirst:   'Ersten Printserver anlegen',
    location:           'Standort',
    noLocation:         '— Kein Standort zugeordnet —',
    locationHint:       'Ordnet den Druckserver einem Standort zu.',
  },

  locations: {
    title:            'Standorte',
    subtitle:         'Alle Standorte dieser Firma',
    add:              'Standort hinzufügen',
    empty:            'Noch keine Standorte angelegt',
    emptyHint:        'Fügen Sie den ersten Standort dieser Firma hinzu.',
    name:             'Standortname',
    namePlaceholder:  'z. B. Hauptstandort Zürich',
    new:              'Neuer Standort',
    edit:             'Bearbeiten',
    autoUpdate:       'Automatische Aktualisierung',
    autoUpdateOn:     'Aktiv',
    paused:           'Pausiert',
    updateSection:    'Automatische Aktualisierung',
    updatePaused:     'Aktualisierung pausieren',
    updatePausedHint: 'Setzt die automatische Aktualisierung der Druckserver an diesem Standort aus.',
    updateChannel:    'Aktualisierungskanal',
    channelStable:    'Stabil',
    channelBeta:      'Beta',
    pinnedVersion:    'Festgelegte Version',
    pinnedVersionHint:'Leer lassen für die neueste Version im gewählten Kanal.',
    latest:           'Neueste',
    deleteTitle:      'Standort löschen?',
    deleteConfirm:    'Möchten Sie {name} wirklich löschen?',
  },

  jobs: {
    title:          'Druckaufträge',
    subtitle:       'Alle Druckaufträge dieser Firma',
    new:            'Neuer Auftrag',
    empty:          'Keine Druckaufträge vorhanden.',
    // T-M18.6: „keine Aufträge" und „keine unter den geladenen" sind zwei
    // verschiedene Aussagen — die Liste blättert, gefiltert wird die geladene
    // Menge (REQ-OPS-033).
    emptyFiltered:     'Unter den geladenen Aufträgen entspricht keiner den gesetzten Filtern.',
    emptyFilteredHint: 'Weitere Aufträge lassen sich unten nachladen.',
    id:             'Auftrag-ID',
    printer:        'Drucker',
    register:       'Kasse',
    status:         'Status',
    createdAt:      'Erstellt am',
    updatedAt:      'Zuletzt aktualisiert',
    payload:        'Payload',
    create:         'Druckauftrag erstellen',
    send:           'Druckauftrag senden',
    sending:        'Wird erstellt …',
    selectRegister: 'Kasse auswählen …',
    payloadLabel:   'JSON-Payload (Payfix-Format)',
    loadExample:    'Beispiel laden',
    invalidJson:    'Ungültiges JSON. Bitte prüfen.',
    created:        'Druckauftrag erstellt',
    sourcePayfix:    'Payfix',
    sourceDashboard: 'Dashboard',
    source:          'Quelle',
    type:            'Typ',
    typePrintjobs:   'Druckaufträge',
    typeReceipts:    'Quittungen',
    // `statusAll` beschriftet den Sammelreiter und benennt keinen Statuswert.
    //
    // ⚠ VIER SCHLÜSSEL DIESES BAUMES SIND AM 2026-08-29 ERSATZLOS ENTFALLEN
    // (T-M29.2, REQ-OPS-059 Präz. 1 (d)): die drei Reiter-Beschriftungen mit
    // dem Wortlaut «Offen» / «In Bearbeitung» / «Abholbereit» und die vierte
    // mit «Abholbereit», die in der Listenzeile stand. Sie trugen Wörter des
    // BEARBEITUNGSstatus an Beschriftungen des ZUSTELLstatus. Die Statusreiter,
    // das Auswahlfeld im Detail, die Listenzeile und das Abzeichen greifen
    // seither auf `status.*`, die zwei Spalten des Abholscreens auf
    // `jobs.workStatus.*`. Ein Wächter hält beides maschinell
    // (`test/statusreiterBeschriftung.test.ts`).
    statusAll:       'Alle',
    allPrinters:     'Alle Drucker',
    allPrintservers: 'Alle Druckserver',
    cashier:         'Mitarbeiter',
    positions:       'Positionen',
    total:           'Total',
    received:        'Empfangen',
    printed:         'Gedruckt',
    paymentMethod:   'Zahlungsart',
    items:           'Pos.',
    posName:         'Artikel',
    posQty:          'Menge',
    posUnit:         'Einzelpreis',
    posTotal:        'Total',
    subtotal:        'Zwischensumme',
    tax:             'MwSt.',
    noItems:         'Keine Positionen vorhanden.',
    resend:          'Nochmals senden',
    deleteTitle:     'Druckauftrag löschen?',
    deleteConfirm:   'Möchten Sie Auftrag {id} wirklich löschen?',
    loadMore:          'Weitere Aufträge laden',
    loadingMore:       'Wird geladen …',
    loadedCount:       '{count} Aufträge geladen',
    endOfList:         'Ende der Liste – alle Aufträge sind geladen.',
    loadMoreError:     'Nachladen fehlgeschlagen.',
    liveFirstPageOnly: 'Laufend aktualisiert wird nur die erste Seite.',
    device:          'Gerät',
    deleteError:     'Löschen fehlgeschlagen.',
    resendError:     'Nachdruck fehlgeschlagen. Der Auftrag wurde nicht erstellt.',
    resendNoPrintserver: 'Nachdruck nicht möglich: dem Kanal ist kein Druckserver zugeordnet (Bildschirm-Kanäle können nicht gedruckt werden).',
    // Zustellstatus (REQ-DM-040) — bewusst als eigene Spaltenüberschrift neben
    // dem Bearbeitungsstatus, damit die zwei Dimensionen nicht verwechselt werden.
    deliveryStatus:  'Zustellstatus',
    // Drucker-Spalte (T-M17.6, REQ-OPS-034 Präz. 3): steht kein Name zur
    // Verfügung, sagt die Oberfläche das — statt eine gekürzte Kennung wie eine
    // Angabe aussehen zu lassen. Die vollständige Kennung steht im Titel.
    printerName: {
      idHint:         'Drucker-Kennung: {id}',
      unresolved:     'Name nicht auflösbar',
      unresolvedHint: 'Zu dieser Kennung gibt es in der geladenen Druckerliste keinen Kanal – er wurde vermutlich gelöscht. Kennung: {id}',
      notLoaded:      'Name nicht geladen',
      notLoadedHint:  'Die Druckerliste ist erst seitenweise geladen, der Name dieses Kanals ist deshalb noch nicht dabei. Ob der Kanal noch besteht, ist damit nicht gesagt – weitere Drucker laden. Kennung: {id}',
    },
    // Bearbeitungsstatus (REQ-SC-019, T-M10.7) — nur Anzeige, kein Schalten.
    workStatus: {
      label:              'Bearbeitungsstatus',
      columnHint:         'Zweite, eigenständige Statusdimension: nur Bestellungen (Arbeitsbons) tragen einen Bearbeitungsstatus. Kassenbons tragen keinen, ihr Feld bleibt deshalb leer. Angezeigt wird er nur an Kanälen mit zugeschalteter Kitchen-TV-Ansicht; an allen anderen Zeilen bleibt das Feld ebenfalls leer — im Auftragsdetail bleibt der Wert dort sichtbar, sobald er von «Offen» abweicht.',
      open:               'Offen',
      inPreparation:      'In Bearbeitung',
      ready:              'Abholbereit',
      done:               'Erledigt',
      unknown:            'Unbekannt',
      unknownHint:        'Dieser Wert gehört nicht zum vorgesehenen Vokabular.',
      notPrintedDoneHint: 'Kein Widerspruch: Zustellung und Bearbeitung sind zwei getrennte Angaben. Der Auftrag hat sein Ziel nie erreicht, wurde betrieblich aber abgeschlossen (automatisch nach vier Stunden).',
      readOnly:           'Nur Anzeige – der Bearbeitungsstatus wird hier nicht geschaltet.',
    },
    // Festgehaltener Entfall am Beleg (REQ-PR-037, REQ-DM-030 Ergänzung,
    // T-M11.12) — warnend, nicht alarmierend: der Auftrag ist zugestellt,
    // aber der Beleg ging unvollständig heraus. Kein Wort aus dem Fehlschlag-
    // Wortfeld, weil dies keiner ist.
    omitted: {
      badge:       'Beleg unvollständig',
      badgeHint:   'Der Auftrag wurde zugestellt, doch einzelne Befehle des Belegs konnte das Druckermodell nicht ausführen. Was entfallen ist, steht im aufgeklappten Auftragsdetail.',
      title:       'Nicht ausgeführte Befehle',
      position:    'Position',
      opcode:      'Opcode',
      opcodeNone:  'kein einzelner Befehl',
      reasonLabel: 'Grund',
      unknownHint: 'Dieser Wert gehört nicht zum vorgesehenen Vokabular.',
      reason: {
        unsupportedByModel: 'Vom Druckermodell nicht unterstützt',
        emptyPayload:       'Keine Nutzdaten',
        invalidParameter:   'Ungültiger Parameter',
        unflushedBuffer:    'Nicht ausgegebener Zeilenpuffer',
        unknownOpcode:      'Unbekannter Druckbefehl',
        logoUnreadable:     'Logo nicht druckbar',
        unknown:            'Unbekannt',
      },
      detail: {
        cut:      'Vollschnitt',
        textline: 'Zeilenpuffer',
        unknown:  'Unbekannt',
      },
    },
    // Ohne Druck zugestellt (REQ-LC-043, T-M15.8) — sachlich, nicht warnend:
    // der Auftrag ist zugestellt, es wurde nur nie gedruckt. Kein Wort aus dem
    // Fehlschlag-Wortfeld, weil dies keiner ist.
    deliveredWithoutPrint: {
      badge:     'Ohne Druck zugestellt',
      badgeHint: 'Dieser Auftrag wurde bewusst nicht gedruckt: der Kanal zeigt Arbeitsbons nur auf dem Bildschirm. Er gilt mit dem Eingang als zugestellt und trägt deshalb keinen Druckzeitpunkt.',
      title:     'Ohne Druck zugestellt',
      // Beschriftung des Abschlusszeit-Feldes im Auftragsdetail. Sie tritt an
      // die Stelle von „Gedruckt" — eine Uhrzeit unter „Gedruckt" behauptete
      // ein Gerät, das nie beteiligt war (REQ-LC-043 (b)).
      timeLabel: 'Zugestellt (ohne Druck)',
    },
    // Woran der Erfolg gemessen wurde (REQ-PS-021 Praez. 2, REQ-DM-030
    // Ergaenzung 2026-09-11). NUR `transportOnly` erzeugt eine Marke;
    // `printerResponse` und ein fehlendes Feld erzeugen nichts. Neutraler Ton,
    // kein Wort aus dem Fehlschlag-Wortfeld: es ist kein Fehler.
    deliveryConfirmation: {
      badge:     'Ohne Druckerbestätigung zugestellt',
      badgeHint: 'Das Druckermodell meldet den Druck nicht zurück; gemessen wurde nur die Übertragung.',
    },
    // Beleginhalt einer Quittung als Vorschau (REQ-OPS-060, T-M29.3) — lesend
    // und ausdrücklich KEINE Druckvorschau. Die Beschriftungen benennen die
    // Belegbefehle, die keinen Text tragen; kein Befehl entfällt still
    // (REQ-PR-020). Für eine Kassenlade gibt es bewusst KEINEN Text: Printerque
    // kennt keinen solchen Befehl (REQ-PR-006, OP-08).
    belegVorschau: {
      title:               'Beleginhalt (Vorschau)',
      abweichungsHinweis:  'Keine Druckvorschau: der gedruckte Beleg kann hiervon abweichen. Zeilenbreite, Schriftgrösse und Bilder entstehen erst im Drucker.',
      u220Hinweis:         'Dieser Beleg ist in der Befehlssprache des TM-U220 verfasst. Dafür besteht keine Vorschau — dieselben Befehlsnummern bedeuten dort etwas anderes, eine Anzeige wäre geraten statt gelesen.',
      leerHinweis:         'Diese Quittung führt keine Belegbefehle.',
      platzhalter: {
        align:           'Ausrichtung',
        textSize:        'Textgrösse',
        cut:             'Schnitt',
        qr:              'QR-Code',
        image:           'Bild',
        textEmpty:       'Textbefehl ohne Inhalt',
        unknown:         'Unbekannter Befehl {opcode} an Position {position}',
        unknownNoOpcode: 'Befehl ohne Befehlsnummer an Position {position}',
      },
    },
  },

  settings: {
    title: 'Einstellungen',

    company: {
      title:            'Firmen',
      subtitle:         'Alle registrierten Firmen',
      eyebrow:          'Einstellungen · Firma',
      add:              'Firma hinzufügen',
      empty:            'Noch keine Firmen angelegt.',
      name:             'Firmenname',
      nameLabel:        'Firmenname *',
      email:            'E-Mail',
      phone:            'Telefon',
      address:          'Adresse',
      city:             'Ort',
      zip:              'PLZ',
      country:          'Land',
      logo:             'Logo',
      description:      'Beschreibung',
      descriptionHint:  'Interne Notizen …',
      companyData:      'Firmendaten',
      bonSettings:      'Bon-Einstellungen',
      bonLogo:          'Bon-Logo',
      bonLogoHint:      'Erscheint oben auf dem Kundenbeleg und dem Stornobeleg, auf der Zwischenrechnung nach dem Schalter unten, nicht auf Abschlüssen und nicht an TM-U220-Druckern. PNG, JPG oder SVG, höchstens 2 MB; wird auf die Druckbreite verkleinert und schwarz-weiss gedruckt.',
      bonLogoDrop:      'Logo hier ablegen oder auswählen',
      // T-M51.4 (REQ-DM-010a Praez. 1 (2)/(4)): Meldungen der Logo-Erfassung,
      // die Beschriftung der Druckvorschau und der Hinweis unter Schlusstext
      // und QR-Code-URL.
      bonLogoFileTooLarge:   'Die Datei ist grösser als 2 MB.',
      bonLogoResultTooLarge: 'Das Logo ist auch verkleinert zu gross zum Speichern. Bitte eine einfachere Datei wählen.',
      bonLogoNotImage:       'Die Datei konnte nicht als Bild gelesen werden.',
      bonLogoPrintPreview:   'Druckvorschau (schwarz-weiss)',
      bonFooterQrHint:       'Erscheinen am Ende des Kundenbelegs, auf der Zwischenrechnung nach den Schaltern unten, nicht auf Stornobelegen und Abschlüssen und nicht an TM-U220-Druckern.',
      // T-M54.5 (REQ-DM-010a Praez. 2 (4)): Kartenueberschrift und die drei
      // Schalter der Zwischenrechnung mit ihrem Hinweis.
      receiptSettings:       'Belegeinstellungen',
      interimReceiptLogo:    'Logo auf Zwischenrechnung drucken',
      interimReceiptFooter:  'Schlusstext auf Zwischenrechnung drucken',
      interimReceiptQr:      'QR-Code auf Zwischenrechnung drucken',
      interimReceiptHint:    'Gilt für die Zwischenrechnung der Kasse, an Epson- und Sunmi-Druckern, nicht an TM-U220-Druckern. Was oben nicht erfasst ist, wird auch auf der Zwischenrechnung nicht gedruckt.',
      bonFooter:        'Bon-Fusszeile',
      qrUrl:            'QR-Code URL',
      usersSection:     'Benutzer',
      usersSubtitle:    'Benutzer dieser Firma und ihre Bearbeitungsrechte',
      addUser:          'Benutzer hinzufügen',
      noUsers:          'Noch keine Benutzer zugeteilt',
      userCol:          'Benutzer',
      emailCol:         'E-Mail',
      removeUser:       'Benutzer entfernen?',
      removeUserConfirm:'Möchten Sie diesen Benutzer aus der Firma entfernen?',
      existingUser:     'Bestehender Benutzer',
      inviteByEmail:    'Per E-Mail einladen',
      userSearch:       'Benutzer suchen …',
      noUsersFound:     'Keine Benutzer gefunden',
      inviteSent:       'Einladung an {email} verschickt!',
      inviteEmailHint:  'Der Benutzer erhält eine E-Mail mit einem Link zum Festlegen seines Passworts.',
      systemRole:       'Systemrolle',
      roleUser:         'Benutzer',
      roleAdmin:        'Administrator',
      deleteTitle:      'Firma löschen?',
      deleteConfirm:    'Möchten Sie {name} wirklich löschen?',
      cannotUndoFull:   'Möchten Sie „{name}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      payfixId:         'Payfix Kunden ID',
      payfixIdHint:     'Wird von Payfix vergeben und kann nicht bearbeitet werden.',
      receiptFooter:    'Schlusstext Quittung',
      footerPlaceholder:'Danke für Ihren Einkauf!',
      alarmCenter:      'Alarmzentrale',
      alarmSectionSub:  'Automatische Benachrichtigungen bei Problemen',
      emailAlarm:       'E-Mail Alarm',
      emailAlarmHint:   'Benachrichtigungen per E-Mail',
      alarmWhen:        'Wann soll alarmiert werden?',
      triggerQueueOffline:      'Queue Offline',
      triggerQueueOfflineDesc:  'Benachrichtigung wenn Printserver-Queue offline geht',
      triggerNotPrinted:        'Druckauftrag nicht gedruckt (10 Min)',
      triggerNotPrintedDesc:    'Benachrichtigung wenn ein Bon nach 10 Minuten noch nicht gedruckt wurde',
      triggerPrinterOffline:    'Druckerstörung',
      // `alarmOnPrinterOffline` traegt ALLE Drucker-Stufen, nicht nur `offline`
      // (T-M42.10); bis zum 2026-09-26 lautete der Text „Drucker Offline“.
      triggerPrinterOfflineDesc:'Benachrichtigung bei jeder Alarmstufe, die am Drucker zugeschaltet ist (Offline, Fehler, Papier fast leer, Deckel offen, Papier leer)',
      // T-M42.10 Teil (b): Alarmierung nicht eingerichtet (utils/alarmEinrichtung.ts).
      alarmNotSetUp:             'Alarmierung nicht eingerichtet',
      alarmNotSetUpNoType:       'Keine Alarmart ist eingeschaltet. Für diese Firma wird derzeit kein Alarm versendet.',
      alarmNotSetUpNoRecipients: 'Es ist kein Empfänger hinterlegt: E-Mail-Alarm einschalten und mindestens eine Adresse erfassen. Bis dahin wird für diese Firma kein Alarm versendet.',
      alarmNotSetUpSavedState:   'Massgeblich ist der gespeicherte Stand.',
    },

    users: {
      title:           'Benutzer',
      subtitle:        'Alle Benutzer dieser Firma',
      eyebrow:         'Einstellungen · Benutzer',
      add:             'Benutzer einladen',
      empty:           'Noch keine Benutzer vorhanden.',
      // Die Leermeldung der Benutzersuche. ⚠ SIE STAND BIS ZUM 2026-09-01
      // HARTKODIERT in `views/settings/UsersView.vue` („Kein Benutzer gefunden
      // für …", an den sechs Sprachdateien vorbei) und ist mit dem Nachtrag am
      // Task T-M30.11 gehoben worden (REQ-OV-002, REQ-OV-005).
      searchEmpty:     'Kein Benutzer gefunden für «{search}».',
      name:            'Name',
      email:           'E-Mail',
      role:            'Rolle',
      status:          'Status',
      lastLogin:       'Letzter Login',
      data:            'Benutzerdaten',
      emailHint:       'E-Mail kann nach Erstellung nicht geändert werden.',
      inviteHint:      'Der Benutzer erhält eine Einladungs-E-Mail zum Festlegen seines Passworts.',
      roleAccess:      'Rolle & Zugriff',
      internalNote:    'Interne Notiz',
      internalNotePH:  'Zuständigkeiten, Abteilung …',
      noAccount:       'Kein Login-Account vorhanden',
      noAccountHint:   'Dieser Benutzer wurde ohne Firebase Auth angelegt und kann sich nicht einloggen. Senden Sie eine Einladungs-E-Mail um das zu korrigieren.',
      inviteSent:      'Einladung verschickt!',
      inviteSentHint:  'Eine E-Mail wurde an {email} gesendet. Der Benutzer kann damit sein Passwort festlegen.',
      deleteTitle:     'Benutzer löschen?',
      deleteConfirm:   'Möchten Sie „{name}" wirklich löschen? Der Benutzer verliert sofort den Zugang.',
      invite:          'Einladung senden',
      invited:         'Eingeladen',
      // ── Mandanten und Einladungen (T-M30.6, REQ-SEC-027 (a), REQ-DM-071) ──
      companies:       'Mandanten',
      companiesHint:   'In diesen Mandanten sieht und bedient der Benutzer die Daten.',
      // Bei der Rolle `admin` tritt dieser Hinweis an die Stelle der Kaestchenliste
      // (REQ-SEC-030 Praez. 1 (c), REQ-SEC-027 (a): die Rolle ist global,
      // `isAdmin()` verlangt keine Mitgliedschaft — T-M38.4).
      companiesAdminHint: 'Administratoren haben Zugriff auf alle Mandanten; eine Zuordnung ist nicht nötig.',
      companiesNone:   'Noch keinem Mandanten zugeordnet.',
      companySearch:   'Firma suchen …',
      companyNoMatch:  'Keine Firma gefunden.',
      companyLimit:    'Ein Benutzer kann höchstens {max} Mandanten haben. Bitte entziehen Sie zuerst einen Mandanten.',
      companyRequired: 'Bitte wählen Sie mindestens einen Mandanten aus, in den eingeladen wird.',
      invitations:     'Offene Einladungen',
      openInvitation:  'Offene Einladung',
      validUntil:      'Gültig bis {date}',
      expiredOn:       'Abgelaufen am {date}',
      reinvite:        'Erneut einladen',
      inviteFailed:    'Die Einladung konnte nicht versendet werden.',
    },

    smtp: {
      title:            'E-Mail SMTP',
      subtitle:         'Einstellungen für den E-Mail-Versand',
      infoText:         'Diese SMTP-Einstellungen sind für benutzerdefinierte E-Mails. Firebase Auth sendet System-E-Mails unabhängig davon.',
      serverConnection: 'Serververbindung',
      authentication:   'Authentifizierung',
      sender:           'Absender',
      statusCard:       'Status',
      encryption:       'Verschlüsselung',
      lastSaved:        'Zuletzt gespeichert',
      testSentTo:       'Test-Mail an {email} gesendet!',
      host:             'SMTP-Host',
      port:             'Port',
      user:             'Benutzername',
      password:         'Passwort',
      fromEmail:        'Absender E-Mail',
      fromName:         'Absendername',
      secure:           'SSL / TLS verwenden',
      test:             'Test-E-Mail senden',
      testSent:         'Test-E-Mail erfolgreich gesendet!',
      save:             'SMTP-Einstellungen speichern',
      noEncryption:     'Keine Verschlüsselung (Port 25)',
      starttls:         'STARTTLS (Port 587)',
      tls:              'SSL/TLS (Port 465)',
      activeLabel:      'SMTP aktiv',
      activeNotice:     'Einladungs-E-Mails und System-Benachrichtigungen werden über diese SMTP-Konfiguration versendet.',
      activeFallback:   'Falls SMTP nicht konfiguriert ist, wird automatisch Firebase Authentication als Fallback verwendet.',
      secretBadge:      'Als Firebase-Secret hinterlegt',
      secretHint:       'Dieses Geheimnis liegt nicht in der Datenbank und wird nicht in den Browser geladen. Gesetzt wird es serverseitig im Firebase-Projekt mit dem Befehl unten. Den Wert bei der Abfrage eingeben oder per Pipe mit printf %s übergeben, nie mit echo: echo hängt einen Zeilenumbruch an, der unverändert ins Geheimnis übernommen wird.',
    },

    api: {
      eyebrow:          'Einstellungen · API',
      title:            'API-Tokens',
      subtitle:         'Zugriffstoken für die öffentliche REST-API',
      tokensTitle:      'API-Tokens',
      tokensSubtitle:   'Tokens für den externen API-Zugriff — dieser Firma und global',
      generate:         'Token erzeugen',
      noCompany:        'Bitte zuerst eine Firma auswählen.',
      empty:            'Noch keine API-Tokens vorhanden.',
      // ── Geltung (Reichweite) je Token (T-M31.4, REQ-SEC-035 (d)) ──────────
      // „Global" ist die Anzeige; der FELDWERT in Firestore heisst unveraendert
      // `provisioning` und bleibt technisch-englisch (REQ-OV-002, REQ-OV-008).
      colScope:         'Geltung',
      scopeGlobal:      'Global',
      scopeCompany:     'Mandant',
      scopeGlobalHint:  'Gilt für alle Mandanten.',
      scopeCompanyHint: 'Gilt nur für diese Firma.',
      globalLabel:      'Globales Token',
      globalHint:       'Gilt für alle Mandanten statt nur für diese Firma. Nur für interne Zugriffe verwenden und mit einem Namen versehen, aus dem der Verwender hervorgeht.',
      revokeGlobalHint: 'Dieses Token gilt für alle Mandanten. Nach dem Widerruf verlieren alle Mandanten sofort den Zugriff darüber.',
      colName:          'Name',
      colPrefix:        'Präfix',
      colStatus:        'Status',
      colCreated:       'Erstellt',
      colExpires:       'Gültig bis',
      colLastUsed:      'Zuletzt verwendet',
      statusActive:     'Aktiv',
      statusRevoked:    'Widerrufen',
      neverExpires:     'Unbefristet',
      revoke:           'Token widerrufen',
      tokenCreated:     'Token erzeugt – jetzt sichern!',
      tokenOnceHint:    'Der Token wird nur jetzt einmal angezeigt. Sicher kopieren.',
      connectionTitle:  'Verbindung',
      authLabel:        'Authentifizierung',
      contentTypeLabel: 'Content-Type',
      connectionNote:   'Übergeben Sie den Token bei jeder Anfrage im Authorization-Header als Bearer-Token.',
      createTitle:      'Neuen API-Token erzeugen',
      createBody:       'Vergeben Sie optional einen Namen und ein Ablaufdatum.',
      nameLabel:        'Name (optional)',
      namePlaceholder:  'z. B. Payfix-Integration',
      expiresLabel:     'Ablaufdatum (optional)',
      expiresHint:      'Leer lassen für ein unbefristetes Token.',
      revokeTitle:      'Token widerrufen?',
      revokeBody:       'Der Token „{name}" wird unwiderruflich widerrufen. Alle Integrationen, die ihn verwenden, verlieren sofort den Zugriff.',
      revokeConfirm:    'Ja, widerrufen',
    },
  },

  companySelect: {
    title:    'Firma auswählen',
    subtitle: 'Wählen Sie eine Firma aus, um fortzufahren.',
    search:   'Firma suchen …',
    empty:    'Keine Firmen gefunden.',
    continue: 'Weiter',
    notFound: 'Keine Firma gefunden für «{query}»',
    // ⚠ ENTFALLEN AM 2026-08-22 (T-M24.3, REQ-OPS-058 (2)) — berichtigt statt
    // gelöscht (REQ-OPS-036 Präz. 6). WORTLAUT BIS DAHIN, in allen sechs
    // Sprachen:
    //   limitReached: 'Es sind weitere Firmen vorhanden: geladen wird eine
    //                  Seite mit {count} Einträgen — weitere laden.'
    //   loadMore:     'Weitere {count} Firmen laden'
    //   loadedCount:  '{count} Firmen geladen'
    //   endOfList:    'Ende der Liste – alle Firmen sind geladen.'
    // Die Firmen-Auswahl lädt seit dem Auftraggeber-Entscheid vom 2026-08-19
    // alle Firmen auf einmal; die vier Sätze hatten keinen Verwender mehr.
    // Die gleichnamigen Sätze unter `printers.*` bleiben unverändert stehen —
    // die Druckerliste blättert weiter (REQ-OPS-032).
  },

  location: {
    offline: 'Standort offline',
  },

  fastline: {
    cameraOpen:    'Kamera öffnen',
    orderNumber:   'Bestellnummer',
    search:        'Suchen',
    scan:          'Scannen',
    scanQr:        'QR-Code scannen',
    // ── DAS TOUCH-TASTENFELD DER HANDEINGABE (REQ-SC-099, T-M23.3) ──────────
    // ⚠ AN DIESER STELLE STANDEN BIS ZUM 2026-08-21 DREI SCHLUESSEL DES
    // ABGELOESTEN SCAN-TERMINALS — berichtigt statt geloescht (REQ-OPS-036
    // Praez. 6): `instruction` („Bitte QR-Code scannen um die Bestellung zu
    // suchen"), `instructionOr` („oder Bestellnummer per Hand eingeben") und
    // `noResults` („Keine Bestellung gefunden für «{query}»"). Sie sind mit
    // T-M23.1 ohne Verwender geblieben (REQ-SC-101) und mit T-M23.3
    // ENTFALLEN — nicht wiederverwendet, und der Grund gehoert hierher:
    //   • `noResults` waere eine ZWEITE Fehlerdeutung neben
    //     `screen.scanNotFound` (REQ-SC-082, REQ-SC-099 (4): „keine eigene
    //     Fehlerdeutung") — genau der Befund, der T-M12.54 ausgeloest hat.
    //   • `instruction` sagt dasselbe wie `scannerReadyHint` der
    //     Statusleiste; derselbe Satz zweimal laeuft in sechs Sprachen
    //     auseinander.
    //   • `instructionOr` nennt die „Bestellnummer" — am Kanal im
    //     Fastline-Modus ist der Suchschluessel aber der OrderMood-Code
    //     (REQ-SC-094 (3), REQ-DM-066). Und REQ-SC-099 (3) verlangt eine
    //     Beschriftung als RUECKFALL bei unlesbarem QR-Code, nicht als
    //     zweite Eingabemoeglichkeit.
    keypadOpen:      'Code eingeben',
    keypadTitle:     'Code von Hand eingeben',
    keypadHint:      'Rückfall, wenn der QR-Code nicht lesbar ist. Scanner und Kamera bleiben der Regelweg.',
    keypadSearch:    'Bestellung suchen',
    keypadBackspace: 'Letztes Zeichen löschen',
    // ── DIE ZWEI ERGEBNISBILDER (REQ-SC-100, T-M23.4) ───────────────────────
    // ⚠ SIE SIND GETRENNT, UND DAS IST EIN AUFTRAGGEBER-ENTSCHEID
    // (2026-08-20, OP-A): „bereits abgeholt" ist NICHT „nicht gefunden". Eine
    // bereits abgeholte Bestellung ist GEFUNDEN, und wer sie scannt, will genau
    // das wissen — samt Zeitpunkt (`screen.alreadyPickedUp*`, REQ-SC-082
    // Praez. 4). Ein gemeinsamer Text fuer beide Faelle waere die Zusammenlegung,
    // die am 2026-08-20 ausdruecklich aufgehoben worden ist.
    // `{seconds}` traegt dieselbe Zahl wie der Zeitgeber des Bildes
    // (`FastlinePickedUpScreen.vue`, `AUTO_SCHLIESSEN_MS`) — zwei Zahlen liefen
    // beim ersten Umbau auseinander.
    pickedUpTitle:     'Abgeholt',
    pickedUpDone:      'Die Bestellung ist abgeschlossen und aus der Liste entfernt.',
    pickedUpAutoClose: 'Dieses Fenster schliesst sich in {seconds} Sekunden von selbst.',
    notFoundTitle:     'Bestellung nicht gefunden',
    notFoundText:      'Dieser Code ist unbekannt.',
    notFoundRescan:    'Erneut scannen',
    notFoundManual:    'Code manuell eingeben',
    scanHint:      'Halte den QR-Code in den Rahmen',
    // Die Rueckmeldung des Scans liegt seit T-M12.21 unter `screen.*`: sie ist
    // an allen drei Bildschirm-Ansichten dieselbe (REQ-SC-082).

    // ── DIE EINE HAUPTAKTION DES ABHOL-DIALOGS (REQ-SC-098 (4), T-M23.2) ────
    // ⚠ SIE HAT AM 2026-08-21 DIE SECHS `handover*`-TEXTE ABGELOEST (berichtigt
    // statt geloescht, REQ-OPS-036 Praez. 6). Bis dahin standen hier
    // `handoverTitle`, `handoverHint`, `handoverNoDetail`, `handoverAllChecked`,
    // `handoverDone` und `handoverComplete` — die Texte der zweistufigen
    // Fast-Line-Uebergabe. Fuenf davon sind mit dem geloeschten Uebergabe-Dialog
    // verwaist (T-M23.1, REQ-SC-101), der sechste mit dieser Umbenennung: das
    // Einzel-Antippen entfaellt an dieser Kanalart (REQ-SC-098 (5)), und die
    // eine Hauptaktion heisst „Abholen" (Auftraggeber-Entscheid).
    pickUp:        'Abholen',
    scannerReady:     'Scanner bereit',
    scannerReadyHint: 'QR-Code auf dem Bon scannen — die Bestellung öffnet sich von selbst.',
  },

  kitchen: {
    toCook:           'Zu kochen',
    tickets:          'Tickets',
    allDone:          'Alles erledigt',
    // Die linke Spalte des Light-Modus (REQ-SC-093, T-M20.12): alle offenen
    // Artikel, bestellungsunabhaengig — eine Zeile je Artikelvorkommen. Die
    // Aufschrift benennt genau das und nicht „Bestellungen".
    openItems:        'Offene Artikel',
    open:             'Offen',
    inProgress:       'In Bearbeitung',
    start:            'Starten',
    markReady:        'Abholbereit',
    done:             'Fertig',
    emptyOpen:        'Keine offenen Aufträge',
    emptyInProgress:  'Keine Aufträge in Bearbeitung',
    emptyReady:       'Keine abholbereiten Bestellungen',
    emptyOrders:      'Keine Bestellungen',
    // ── Einzelfertigmeldung (REQ-SC-070, T-M12.5) ──────────────────────────
    // `doneAll` ersetzt `done` an der Schaltflaeche, sobald ALLE nicht
    // stornierten Positionen gemeldet sind. Die drei `action*`-Meldungen sind
    // nach dem HTTP-Status geschieden, nie nach dem Wortlaut der Servermeldung
    // (Lehre aus T-M12.21): 401 → `actionExpired`, 400/404 → `actionStale`,
    // sonst `actionFailed`. Vor dem Bildschirm steht jemand mit Pfanne in der
    // Hand — jede Meldung sagt, was zu tun ist.
    doneAll:          'Alles fertig!',
    actionFailed:     'Nicht gespeichert. Bitte nochmals antippen.',
    actionStale:      'Der Auftrag hat sich verändert. Die Ansicht aktualisiert sich selbst.',
    actionExpired:    'Die Anmeldung dieses Bildschirms ist abgelaufen. Bitte die Seite neu laden.',
    // ── Gang-Gruppierung und Gang-Start (REQ-SC-068, T-M12.8) ──────────────
    // `gangLabel` traegt die Gang-Kennung als ZEICHENKETTE ein — `Gang 2`,
    // aber auch `Gang Ürli` (fixture-belegt). Sie wird woertlich uebernommen
    // und nie umgeformt: der Bildschirm nennt den Gang so, wie ihn der Bon
    // nennt (`print-server/src/render/work-receipt.js:251`).
    gangLabel:        'Gang {gang}',
    startGang:        'Gang starten',
    // ── Artikel-Countdown (REQ-SC-071, T-M12.6) ────────────────────────────
    // Aufschrift der Startschaltflaeche; `{minutes}` ist die Produktionszeit
    // aus `product_time`, unveraendert von der Kasse. Der LAUFENDE Countdown
    // traegt keinen Text — er zeigt eine Dauer als `m:ss` und ist damit in
    // allen sechs Sprachen dieselbe Anzeige (kein Datum, kein Gebietsschema).
    timerStart:       '{minutes} Min.',
    // ── Nachtraegliche Aenderungen (REQ-SC-072, T-M12.7) ───────────────────
    // Beschriftung der roten Annahme-Schaltflaeche, wenn die sich ergebende
    // Menge auf null oder darunter faellt. Sonst traegt die Schaltflaeche die
    // sich ergebende MENGE samt Artikelnamen — Kassendaten und damit kein
    // Uebersetzungsschluessel (REQ-OV-002).
    fullyCancelled:   'Komplett storniert',
    // ── Trefferdialog des QR-Abhol-Scans (REQ-SC-073, T-M12.10) ────────────
    // Die Rueckmeldung selbst (gefunden / bereits abgeholt samt Zeitpunkt /
    // unbekannt) liegt geteilt unter `screen.*` — hier stehen nur die
    // Einzelheiten, die der Kitchen TV zusaetzlich zeigt.
    // Der BENANNTE GRUND aus REQ-SC-087 stand bis zum 2026-08-11 hier als
    // `scanNotReady`; er liegt seit T-M12.54 unter `screen.scanNotReady`, weil
    // er nach REQ-SC-087 „an allen drei Ansichten" derselbe Satz ist.
    // ── DIE TISCHANGABE (REQ-SC-066 Praez. 1, Nachfuehrung 1 (h), T-M48.1) ──
    // EIN Schluessel fuer Ticketkopf UND Trefferdialog; die Nummer kommt aus
    // `tischNummer` (`utils/kitchenView.ts`). Er ersetzt `scanTable` („Tisch“,
    // bis 2026-10-08 als Beschriftung vor der Angabe — sie ergaebe jetzt
    // „Tisch: Tisch 12“).
    tableNumber:      'Tisch {number}',
    scanReceived:     'Eingang',
    scanNoDetail:     'Einzelheiten dieser Bestellung liegen auf diesem Bildschirm nicht vor.',
    // ── KARTENSTATUS DER FASTLINE-DARSTELLUNG (REQ-SC-097 (2), T-M23.1) ────
    // Er tritt an die Stelle des Spaltenknopfs „Offen", der an einem Kanal im
    // Fastline-Modus ersatzlos entfaellt. ⚠ ANZEIGE UND KEIN DATENBANKWERT:
    // der Bearbeitungsstatus bleibt in Firestore woertlich `open`
    // (REQ-DM-041, REQ-OV-002, REQ-OV-005).
    waitingForPickupScan: 'Wartet auf Abholscan',
  },

  screen: {
    keyPrompt:      'Anzeige-Schluessel eingeben',
    keyPlaceholder: 'Anzeige-Schluessel',
    connect:        'Verbinden',
    connecting:     'Verbindung wird hergestellt …',
    invalidKey:     'Ungueltiger Anzeige-Schluessel.',
    notPrinted:     'Bon noch nicht gedruckt',
    limitReached:   'Es werden nur die neuesten {count} Aufträge angezeigt.',
    // ── Abgeschaltete Ansicht (REQ-SC-079, T-M12.19) ────────────────────────
    // Der Hinweis steht vor jemandem, der vor einem Küchenbildschirm steht:
    // er benennt die Ansicht, den Kanal und den Weg zurück — und nicht einen
    // Fehler, denn es ist keiner.
    viewDisabledTitle:       'Diese Ansicht ist abgeschaltet',
    viewDisabledKitchenTv:   'Der Kitchen TV ist für diesen Kanal nicht zugeschaltet.',
    viewDisabledAbholscreen: 'Der Abholscreen ist für diesen Kanal nicht zugeschaltet.',
    viewDisabledChannel:     'Kanal: {name}',
    viewDisabledHelp:        'Sie können die Ansicht im Dashboard unter «Drucker» für diesen Kanal einschalten.',
    // ── Übernahme des Bildschirm-Modus (REQ-SC-104 (5), T-M25.3) ────────────
    // An einem Kanal ist genau EIN Modus aktiv. Der neu geöffnete Bildschirm
    // nennt den aktiven Modus BEIM NAMEN und sagt, dass er dadurch deaktiviert
    // wird; erst die Bestätigung schreibt (REQ-SC-104 (5)). Die drei
    // Modusnamen sind Schlüssel und keine Literale: sie stehen in einem Satz,
    // der in sechs Sprachen geführt wird (REQ-OV-002). Die Feldwerte selbst
    // bleiben technisch-englisch (`normal`/`light`/`fastline`, REQ-DM-068 (1)).
    modeNameNormal:   'Kitchen TV',
    modeNameLight:    'Kitchen TV Light',
    modeNameFastline: 'Fastline',
    takeoverTitle:    'Ein anderer Modus ist aktiv',
    takeoverWarning:  'An diesem Kanal läuft zurzeit «{active}». Wenn Sie hier «{own}» starten, wird «{active}» deaktiviert.',
    takeoverIdle:     'Dieser Bildschirm hat «{own}» noch nicht übernommen.',
    takeoverConfirm:  '«{own}» hier starten',
    takeoverRunning:  'Wird übernommen …',
    takeoverHint:     'Solange Sie nicht bestätigen, ändert sich nichts – der andere Bildschirm läuft weiter.',
    // ── Rueckmeldung des QR-Abhol-Scans (REQ-SC-082, T-M12.21) ──────────────
    // Geteilt von Kitchen TV, Abholscreen und Fastline. `{time}` traegt seit
    // dem 2026-08-18 den ABHOLZEITPUNKT `doneAt` und erst ersatzweise
    // `scannedAt` (REQ-SC-082 Praez. 4, T-M22.3; berichtigt statt geloescht,
    // REQ-OPS-036 Praez. 6 — bis dahin stand hier: „`alreadyPickedUpNoTime`
    // gilt, wenn die Bestellung ohne Scan abgeschlossen wurde"). Das trifft
    // nicht mehr zu: ein Abschluss ohne Scan traegt `doneAt` und nennt damit
    // sehr wohl einen Zeitpunkt. `alreadyPickedUpNoTime` gilt ab jetzt, wenn
    // BEIDE Felder fehlen — dann erscheint die Kennzeichnung OHNE Zeitpunkt,
    // und es wird keiner erfunden.
    alreadyPickedUp:       'Bereits abgeholt',
    alreadyPickedUpAt:     'Abgeholt am {time}',
    alreadyPickedUpNoTime: 'Zeitpunkt nicht vermerkt',
    scanFound:             'Bestellung gefunden',
    scanCompleted:         'Abgeschlossen',
    scanNotFound:          'Keine passende Bestellung gefunden',
    scanError:             'Fehler beim Scannen',
    // ── Der BENANNTE GRUND (REQ-SC-087 Gegenrichtung, T-M12.54) ─────────────
    // Trifft der Scan eine Bestellung in «Offen» oder «In Bearbeitung», wird
    // `scannedAt` vermerkt (REQ-SC-041) und sonst nichts. Der Satz sagt genau
    // das — eine Ansicht, die dazu schweigt, laesst die Kueche raten, ob der
    // Scan angekommen ist. EIN Schluessel fuer alle drei Ansichten: er stand
    // bis zum 2026-08-11 doppelt (`kitchen.scanNotReady`,
    // `fastline.handoverNotReady`) und war in zwei Sprachen bereits
    // auseinandergelaufen.
    scanNotReady:          'Der Scan ist vermerkt. Abgeschlossen wird erst aus «Abholbereit».',
    // ── Zahleneingabe und Scanner am Abholscreen (REQ-SC-012, T-M12.23) ─────
    // Beide Wege führen in dieselbe serverseitige Funktion; abgeschlossen wird
    // nur eine abholbereite Bestellung (REQ-SC-087 Hauptsatz).
    pickupPrompt: 'Bestellnummer eingeben oder scannen',
    pickupNumber: 'Bestellnummer',
    pickupSubmit: 'Abholen',
    // ── Sammelabschluss (REQ-SC-083, T-M12.22) ──────────────────────────────
    // Die Rückfrage MUSS benennen, was abgeschlossen wird und wie viele — und
    // ausdrücklich sagen, dass nichts gedruckt wird. Ein blosses «Sind Sie
    // sicher?» erfüllt REQ-SC-083 nicht.
    completeAll:        'Alle abschliessen',
    completeAllTitle:   'Alle Bestellungen abschliessen?',
    completeAllBody:    '{count} Bestellungen aus «In Bearbeitung» und «Abholbereit» werden abgeschlossen. Das ist eine Bereinigung der Anzeige: Es wird nichts gedruckt und kein Bon ausgelöst.',
    completeAllChunks:  'Es sind mehr als {max} Bestellungen. Sie werden in {calls} Schritten abgeschlossen; bricht ein Schritt ab, bleiben die Bestellungen der späteren Schritte offen.',
    completeAllConfirm: 'Ja, {count} abschliessen',
    completeAllDone:    '{count} Bestellungen abgeschlossen.',
    // ── Die FAST-LINE-RUECKFRAGE (REQ-SC-075, T-M12.13) ─────────────────────
    // Sie steht NUR an einem Kanal im Fastline-Modus und NUR, wenn wenigstens
    // eine der betroffenen Bestellungen nie gescannt wurde (`scannedAt` fehlt am
    // LEBENDEN Dokument). Sie benennt genau diesen Grund — der Satz darueber
    // sagt, WAS abgeschlossen wird, dieser sagt, WARUM man zoegern soll.
    completeAllNoScan:  'Nicht mit einem QR-Code abgeholt: {count} Bestellungen tragen keinen Abhol-Scan. Trotzdem abschliessen?',
    // ── Herkunfts-Label am Fastline-Kanal (REQ-SC-095, T-M20.15) ────────────
    // Payfix woertlich (Antwort zu OP-164, 2026-08-18): «Bestellungen im
    // Fastline-Modus ein sichtbares Label — «OrderMood» oder «Kasse» —, damit
    // der Ursprung auch am Bildschirm erkennbar ist.» Gelesen wird die HERKUNFT
    // des Auftrags (REQ-DM-033), nicht `fastLane` und nicht der Kanal.
    // «OrderMood» ist ein Eigenname und steht in allen sechs Sprachen gleich;
    // uebersetzt wird allein «Kasse».
    originOrderMood: 'OrderMood',
    originRegister:  'Kasse',
  },

  // ── Das Kennzeichen des Testsystems (T-M32.7, REQ-OPS-061) ────────────────
  // Der Streifen am oberen Rand der Verwaltungsoberflaeche. Uebersetzt wird
  // allein das WORT „Testsystem"; `{projektId}` ist ein technischer Name und
  // steht in jeder Sprache gleich (REQ-OV-002, REQ-OV-008).
  // Der Emulator-Wortlaut ist der Sonderfall des lokalen Entwicklungswegs: dort
  // lautet die Projekt-ID `printerque-prod`, weil sie beim Emulatorlauf nur die
  // Audience der ID-Token ist (REQ-OPS-064 (a)) — ohne den Zusatz stuende ein
  // Widerspruch auf dem Bildschirm.
  umgebung: {
    testBanner:         'TESTSYSTEM · {projektId}',
    testBannerEmulator: 'TESTSYSTEM · {projektId} · Emulator',
  },
}
